/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=4b85e56a&scoped=true&"
import script from "./Summary.vue?vue&type=script&setup=true&lang=js&"
export * from "./Summary.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Summary.vue?vue&type=style&index=0&id=4b85e56a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85e56a",
  null
  
)

export default component.exports